import { Link } from 'react-router-dom'
import { styled } from 'styles'
import { Box } from './elements/Box'
import { Flex } from './elements/Flex'
import { routes } from 'configs/constants'
import moment from 'moment'
import { DltEmailIcon, LocationIcon, NewLinkedInIcon, NewTwitterIcon, PhoneIcon } from './icons'
import { TERMINOLOGY } from 'utils/enum'

const Footer = () => {
  return (
    <StyledFooter>
      <StyledWrapper>
        <Flex direction="column">
          <Box as="img" src="/images/dlt-alert-logo.png" alt="dlt alert company logo" css={{ maxWidth: 190 }} />
          {/* <Box as="img" src="/images/dlt-warranty.png" alt="dlt alert company logo" css={{ maxWidth: 100 }} /> */}
          <Box as="p" css={{ fontSize: 13, mt: '1rem' }}>
            Cyber Security Warranty Provider with {TERMINOLOGY.benefit.plural} & Protections
          </Box>
          <Flex css={{ gap: '0.7rem' }}>
            <LocationIcon />
            <Box as="p" css={{ fontSize: 13 }}>
              22316 Westheimer Parkway, #708, Katy, TX. 77450
            </Box>
          </Flex>
          <Flex css={{ gap: '1rem' }}>
            <DltEmailIcon />
            <Box as="p" css={{ fontSize: 13 }}>
              info@dltalert.com
            </Box>
          </Flex>
          <Flex css={{ gap: '1rem' }}>
            <PhoneIcon />
            <Box as="p" css={{ fontSize: 13 }}>
              838-910-3219
            </Box>
          </Flex>
        </Flex>
        <LinksColumn css={{ 'mt': '30px', '@sm': { gridArea: 'links', alignItems: 'center', mt: '0' } }}>
          <Box as="h4" css={{ paddingRight: '18px' }}>
            Learn
          </Box>
          <ul>
            <li>
              <Link to={routes.about}>{TERMINOLOGY.benefit.plural} </Link>
            </li>
            <li>
              <Link to={routes.about}>About Us </Link>
            </li>
            <li>
              <Link to={routes.about}>Blog </Link>
            </li>
          </ul>
          <Flex css={{ gap: '14px', mr: '10px' }}>
            <NewTwitterIcon />
            <NewLinkedInIcon />
          </Flex>
        </LinksColumn>

        {/* <LinksColumn css={{ gridArea: 'social' }}>
          <h4>Socials</h4>
          <ul>
            <li>
              <a href="https://www.linkedin.com/company/dlt-alert/" rel="noreferrer" target="_blank">
                Linkedin
              </a>
            </li>
            <li>
              <a href="https://twitter.com/DLTAlert" rel="noreferrer" target="_blank">
                Twitter
              </a>
            </li>
          </ul>
        </LinksColumn> */}

        <LinksColumn css={{ 'mt': '30px', '@sm': { gridArea: 'contact', alignItems: 'center', mt: '0' } }}>
          <Box as="h4" css={{ paddingRight: '37px' }}>
            Connect
          </Box>
          <ul>
            {/* <li>
              <a href="mailto:info@dltalert.com">info@dltalert.com</a>
            </li> */}
            <li>
              <Link to={routes.about}>Get a Quote </Link>
            </li>{' '}
            <li>
              <Link to={routes.about}>Support </Link>
            </li>{' '}
            <li>
              <Link to={routes.about}>Login </Link>
            </li>
            <li>
              <Box as="img" src="/images/dlt-warranty.png" alt="dlt alert company logo" css={{ maxWidth: 100 }} />
            </li>
          </ul>
        </LinksColumn>
        {/* <LinksColumn css={{ gridArea: 'terms' }}>
          <Box as="a" href="/terms-of-service.html" css={{ pt: '0px !important', mb: '$2 !important' }}>
            Terms & Conditions
          </Box>

          <Box as="a" href="/privacy-policy.html">
            Privacy & Policy
          </Box>
        </LinksColumn> */}
      </StyledWrapper>
      <Flex justify="between" direction="column" css={{ 'mt': '20px', '@sm': { flexDirection: 'row' } }}>
        <Box as="p" css={{ fontSize: '14px', mb: 0 }}>
          © {moment().year()} DLT Alert. All rights reserved.
        </Box>
        <Flex direction="column" css={{ '@sm': { flexDirection: 'row' } }}>
          <Box as="a" href="/terms-of-service.html" css={{ pt: '0px !important', mb: '$2 !important', pr: '40px', fontSize: 14 }}>
            Terms & Conditions
          </Box>

          <Box as="a" href="/privacy-policy.html" css={{ fontSize: 14 }}>
            Privacy & Policy
          </Box>
        </Flex>
      </Flex>
    </StyledFooter>
  )
}

const StyledFooter = styled('footer', {
  'bgColor': '#1D1B3B',
  'px': '40px',
  'py': '$7',
  '@md': {
    px: '160px',
  },
})

const StyledWrapper = styled('div', {
  'borderBottom': '1px solid #E4E4E726',
  'display': 'grid',
  'gridTemplateAreas': `
    "logo"
    "links"
    "contact"
  `,
  'gridTemplateColumns': '1fr', // Each row will take up full width
  'gridAutoRows': 'auto',
  '@sm': {
    gridTemplateAreas: `
      "logo links contact "`,
    maxWidth: 'fit-content',
    mt: 27,
    mx: 'auto',
    gridTemplateColumns: '1fr 1fr 1fr', // Each section gets equal width
    gridAutoRows: 'auto',
  },
  // '@md': {

  // },
})

const LinksColumn = styled('div', {
  'display': 'flex',
  'flexDirection': 'column',
  'alignItems': 'flex-start',
  '& > ul': {
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
  '& > h4': {
    fontWeight: '$normal',
    fontSize: '$base',
    mb: '$3',
  },
  '& a, & .info': {
    display: 'inline-block',
    fontSize: '$sm',
    color: '$white',
    opacity: 0.75,
    py: '$2',
    mb: '$1',
    textDecoration: 'none',
  },
})

export default Footer
